import { orgSearch } from '../helpers';

export function getProgramDataAPI(programID, callback) {
  const data =
    '?detail_indice={"_index":"ibl-dm.public.dl_catalog_app_program"}&detail_scope={"id":"' +
    programID +
    '"}';
  orgSearch(data, function (data) {
    callback(data?.results[0]);
  });
}

export function getProgramCoursesAPI(programID, callback) {
  const data = '?program_course_listing=' + programID;
  const courseArray = [];
  orgSearch(data, function (data) {
    data?.results.map((course) => {
      const course_id = course._source.course_id;
      const data =
        '?detail_indice={"_index":"ibl-dm.public.dl_catalog_app_course"}&detail_scope={"_id":"' +
        course_id +
        '"}';
      orgSearch(data, function (data) {
        courseArray.push(data.results[0]);
        callback(courseArray);
      });
    });
  });
}
